import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.imageTargets.forEach((img) => {
      if (img.complete) {
        this.extractColor(img)
      } else {
        img.addEventListener("load", () => this.extractColor(img), { once: true })
      }
    })
  }

  extractColor(img) {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    canvas.width = 1
    canvas.height = 1
    ctx.drawImage(img, 0, 0, 1, 1)
    const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data
    img.closest(".post__image").style.backgroundColor = `rgb(${r}, ${g}, ${b})`
  }
}
